export default {
    ledium_title: 'Ledium MEC',
    logout_user: 'Logout {0}',

    dashboard_title: 'Dashboard',
    dashboard_description: 'This is your Project Control Center. You can start, stop, pause your growing Projects created in the Project Editor.',

    pfd_unit: 'µmol/m²/s',
    irradiance_unit: 'W/m²',
    dli: 'DLI',
    dli_unit: 'mol/m²/day',
    dli_total_unit: 'mol/m²',
    dli_current_section_day: 'Current section day',
    dli_sum_all_sections: 'Sum all sections',
    pfd: 'PFD',
    irradiance: 'Irradiance',
    intensity: 'Intensity',
    current_intensity: 'Current intensity',
    mix_intensity: 'Mix intensity:',
    original_light_recipe_intensity: 'Original Light Recipe Intensity:',

    X_bit: '{0} bit',
    bit: 'bit',
    channel_dmx_value: 'Channel DMX value',

    project_editor_title: 'Project Editor',
    project: 'Project',
    project_description: 'This is the place, where you can match your Spectrum Mixes to the original Light Recipes.',
    no_project: 'You do not have any Projects now.',
    search_for_project: 'Search for Project',
    select_recipe: 'Select Growth Recipe',
    project_running_lock: 'A running Project cannot be modified or deleted',
    project_editor_recipe_info: 'This Growth Recipe uses {0} unique Light Recipe{0,choice,0#s|1#|1<s}.',
    project_editor_missing_light_recipes:
        'The Growth Recipe does not have any Light Recipes in the Circadian settings. You are probably trying to use an unfinished Growth Recipe.',
    no_recipe_selected: 'No recipe selected',
    project_linked_spectrum_mix: 'Can not be selected, Spectrum Mix or a Lighting Device in the Spectrum Mix is used by Project "{0}"',
    project_editor_select_spectrum_mix: 'Select Spectrum mix for Light Recipe "{0}"',
    do_you_want_to_stop_the_project: 'Do you really want to stop the Project?',
    original_light_recipe: 'Original Light Recipe',
    mixed_spectrum: 'Mixed spectrum',
    value: 'Value',
    one_bit_on: 'ON',
    one_bit_off: 'OFF',
    jump_back: 'Jump back to the {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {0} section',
    jump_forward: 'Jump forward to the {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {0} section',
    restart_current_circadian: 'Restart current circadian',

    zone_device_management: 'Device management',

    light_channels_title: 'My Lighting Devices',
    light_channel: 'Lighting Device',
    light_channel_description:
        'Available Lighting Devices for you. Upload, edit, remove your lighting equipments here. Lighting Device could  be a standalone luminaire, part of a LED fixture (blue LEDs in an RGBW light), or either a large inslallation,  which will be controlled separately from the others. ',
    no_light_channel: 'You do not have any Lighting Devices now.',
    search_for_light_channel: 'Search for Lighting Device',
    select_light_channel: 'Select Lighting Devices',
    light_channel_running_project: 'The Lighting Device is used by a running Project: {0}',
    light_channel_linked_project: 'The Lighting Device is used by Spectrum Mix "{0}" for Project "{1}" and can not be deleted.',
    light_channel_used_in_mix: 'The Lighting Device is used by Spectrum Mix "{0}" and can not be deleted.',
    resolution: 'Resolution',
    light_channel_details: 'DMX: {0}, {1} bit',
    intensity_value_X_to_Y: 'Relative intensity value ({0} - {1})',
    you_should_upload_a_valid_spectrogram_csv_file_before_save: 'You should upload a valid spectrogram CSV file before save.',
    test: 'Test',
    test_channel: 'Test channel',
    search_next_free_channel: 'Search next free DMX channel',
    next_free_channel_can_not_allocate: 'Can not allocate free DMX channel for {0} bit resolution!',
    next_free_channel_found: 'Found the lowest free DMX channel for {0} bit resolution.',
    dmx_channel: 'DMX Channel',
    dmx_channel_X_to_Y: 'DMX Channel ({0}-{1})',
    dmx_channel_channel_info: 'The {0} bit resolution will use {1} sequential channels (channel {2} to channel {3})',
    dmx_channel_channel_conflict:
        'There are no {0} sequential channels available, starting with channel {1}. You could use different starting channel manually of by using the "Search next free channel" button.',
    USED_IN_SPECTRUM_MIX: 'Light channel is used in {0} Spectrum Mix, zone switching is not possible',

    spectrum_mixer_title: 'Spectrum Mixer',
    spectrum_mix: 'Spectrum Mix',
    spectrum_mixer_description: 'You can make a Spectrum Mix with your available Lighting Devices, which will simulate a Light Recipe.',
    no_spectrum_mix: 'You do not have any Spectrum Mixes now.',
    search_for_spectrum_mix: 'Search for Spectrum Mix',
    spectrum_mix_running_project: 'The Spectrum Mix is used by a running Project: {0}',
    spectrum_mix_linked_project: 'The Spectrum Mix is used by Project "{0}" and can not be deleted',
    spectrum_mix_linked_light_channel_another_mix:
        'Can not be selected, Lighting Device is added to "{0}" Spectrum Mix that have a Project "{1}" related Lighting Device',
    spectrum_mix_linked_light_channel_project: 'Can not be selected, Lighting Device is used by Project "{0}"',
    spectrum_mix_auto_mix: 'Auto Mix',
    spectrum_mix_similarity: 'Spectral similarity',
    spectrum_mix_realtime_lights: 'Realtime lights',
    spectrum_mix_realtime_lights_forced_disable: 'Realtime lights were disabled because a Lighting Device was edited or deleted.',
    spectrum_mix_settings_list_view: 'List view',
    spectrum_mix_settings_carousel_view: 'Carousel view',
    add_new_spectrum_mix_button: 'Add new Spectrum Mix',

    detail_range: 'Range',
    detail_blue: 'Blue',
    detail_fr: 'Far Red',
    detail_green: 'Green',
    detail_ir: 'Infrared',
    detail_red: 'Red',
    detail_sum: 'Summary',
    detail_uv: 'Ultraviolet',
    detail_uvA: 'UV-A',
    detail_uvB: 'UV-B',
    detail_uvC: 'UV-C',
    detail_visibleSum: 'Visible range',
    detail_ppfd: 'PPFD',
    detail_red_blue_ratio: 'Red/Blue ratio',

    zone_manage_projects: 'Manage Projects',

    recipes_title: 'Growth Recipes',
    recipe: 'Recipe',
    save_recipe: 'Save Growth Recipe',
    recipe_description:
        'Growth Recipes are based on Sections and Light Recipes. Every Section has a timeline you can place Light Recipes on. You could have unlimited number of Sections.',
    no_recipe: 'You do not have any Growth Recipes now',
    search_for_recipe: 'Search for Growth Recipe',
    recipe_linked_project: 'The Growth Recipe is used by at least one Project, can not be deleted',
    recipe_locked_project: 'The Growth Recipe is used by at least one running Project, can not be modified',
    recipe_section_saved_info: 'Section is updated, but the Growth Recipe is not saved yet!',
    add_new_section_button: 'Add new Section',
    new_section_temporary_name: 'NEW SECTION',
    add_new_light_event_button: 'Add new light event',
    delete_circadian_event_title: 'Delete circadian event',
    delete_circadian_event_message: 'Do you want to delete this circadian event?',
    event_time: 'Event: {0}:{1}',
    circadian_length_hours: 'hours',
    save_section: 'Save section',
    delete_section_title: 'Delete section',
    delete_section_message: 'Do you want to delete this section?',
    discard_section_changes_title: 'Discard changes',
    discard_section_changes_message: 'You have unsaved changes. Do you want to discard them?',
    unsaved_changes_title: 'Unsaved changes',
    unsaved_changes_message: 'You have unsaved changes. If you leave this page, your changes will be lost.',
    leave_page: 'Leave',
    stay_on_page: 'Stay',
    circadian_repeat_time: 'Repeat time',
    section_timeline_info: 'The timeline is always in 24hr format, the running time will be adjusted proportionately to the circadian length.',
    circadian_length: 'Circadian length',
    select_section_background_color: 'Select color for the section',
    hours: 'Hours',
    show_colors: 'Show colors',

    light_recipes_title: 'Light Recipes',
    light_recipe: 'Light Recipe',
    light_recipe_description:
        'Light Recipe is a light spectrum recorded with a spectrophotometer or created by yourself. This is the theoretical fundamental of the system. You can upload or draw spectrograms here. The controller hardware will simulate these Light Recipes as good as possible with your available Lighting Devices.',
    no_light_recipe: 'You do not have any Light Recipes now.',
    search_for_light_recipe: 'Click here for search Light Recipes',
    light_recipe_running_project: 'The Light Recipe is used by at least one running Project, can not be modified',
    light_recipe_linked_project: 'The Light Recipe is used by at least one Project, can not be deleted',
    light_recipe_csv_upload_title: 'Are you sure?',
    light_recipe_csv_upload_message: 'The uploaded CSV will overwrite the existing spectrum',
    light_recipe_download_csv: 'Download Spectrogram in CSV',
    download_spectrum_csv: 'Download Spectrogram in CSV',

    add_new_project: 'Add new Project',
    start_project: 'Start Project',
    project_started: 'Project is successfully started.',
    stop_project: 'Stop Project',
    stop_all_running_projects: 'Stop All Running Projects',
    stop_all_running_confirm:
        'There {0,choice,0#are|1#is|1<are} {0} running project{0,choice,0#s|1#|1<s}. Are you sure you want to stop {0,choice,0#them all|1#it|1<them all}?',
    project_stopped: 'Project is successfully stopped.',
    pause_project: 'Pause Project',
    resume_project: 'Resume Project',
    project_paused: 'Project is successfully paused.',
    project_resumed: 'Project is resumed.',
    project_detailed_status: 'Current section is {0}, {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {2} at {3}%',
    project_is_running_for: 'The Project is running for {0}',
    set_start_time: 'Set start time',
    project_is_starts_with_a_delay_within: 'The Project starts with a delay, within {0}',
    project_is_paused_at: 'Project is paused at {0}.',
    project_detailed_last_status: 'Last section was {0}, {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {2} at {3}%',

    are_you_sure: 'Are you sure?',
    do_you_want_to_delete_X: 'Do you want to delete "{0}"?',
    do_you_want_to_duplicate_X: 'Do you want to duplicate "{0}"?',
    X_is_successfully_duplicated: '{0} is successfully duplicated',
    something_went_wrong: 'Something went wrong...',

    name: 'Name',
    add_new: 'Add new',
    view: 'View',
    edit: 'Edit',
    edit_zone: 'Edit zone',
    details: 'Details',
    duplicate: 'Copy',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    ok: 'Ok',

    you_can_change_the_order_of_the_sections_by_drag_n_drop: 'You can change the order of the sections by drag & drop.',
    wave_length_intensity: 'Wavelength',
    target_wave_length_intensity: 'Original Light Recipe spectrum',
    editing_light_recipe: 'Editing Light Recipe',
    X_is_successfully_added: '{0} is successfully added',
    X_is_successfully_updated: '{0} is successfully updated',
    load_item_failed: 'Failed to load the item.',
    unable_to_save_the_data: 'Unable to save the data.',

    description: 'Description',
    no_description: 'No description',
    select_light_recipe: 'Select Light Recipe',
    no_light_recipe_selected: 'No Light Recipe selected',
    dark_light_recipe_name: 'Dark',
    dark_light_recipe_description: 'All lights off',

    upload_csv_file: 'Upload CSV file',
    csv_file_is_successfully_uploaded: 'CSV file is successfully uploaded',
    could_not_parse_spectrogram_data_in_the_uploaded_CSV_file: 'Could not parse spectrogram data in the uploaded CSV file!',

    login_successful: 'Successfully logged in',
    logout_successful: 'Logged out',
    socket_disconnected: 'Connection lost — reconnecting...',
    login_failed: 'Authentication failed',
    login_name: 'Login name',
    password: 'Password',
    sign_in: 'Sign In',

    // item errors
    spectrum_mix_not_exists: 'A paired Spectrum mix is no longer available',
    spectrum_mix_not_available: 'There is no Spectrum Mix created for a Light Recipe',
    spectrum_mix_not_set: 'A Light Recipe does not have paired Spectrum Mix',
    target_spectrum_not_exists: 'One of the Light Recipes in the added Recipe is no longer available',
    recipe_not_set: 'Recipe is not set for the Project',
    recipe_not_exists: 'The added Recipe is no longer available',

    // form errors
    this_field_is_required: 'This field is required',
    invalid_number: 'Invalid number',
    the_value_must_be_positive: 'The value must be positive',
    the_value_should_be_minimum_X: 'The value should be minimum {0}',
    the_dmx_channel_is_used: 'The DMX channel is used',
    the_value_should_be_maximum_X: 'The value should be minimum {0}',
    the_name_should_be_unique_X_is_already_used: 'The name should be unique. {0} is already used.',

    settings: 'Settings',
    settings_description: 'Application settings and update',
    zone_settings: 'Settings',
    update_to_version: 'Update to version {0}',
    update_in_progress: '{0}%, {1}kb/sec, ETA: {2}s',
    update_downloaded: 'Update is downloaded.',
    installing_update: 'Installing update...\nIt can take several minutes.\nDo not refresh the page.',
    restoring_database: 'Restoring database...',
    no_update_available: 'No update available',
    searching_for_update: 'Searching for update...',
    enable_nightly_build_installs: 'Enable Nightly build installs',
    application_version: 'Application version: {0}',
    offline_mode: 'Offline Mode',
    offline_mode_description: 'Disables online features and allows manual system clock configuration.',
    offline_mode_online_warning: 'Not recommended to enable offline mode when the device has an active internet connection.',
    offline_mode_enabled: 'Enable offline mode',
    set_date_and_time: 'Set Date and Time',
    set_date_and_time_description: 'Manually set the system clock.',
    set_date_and_time_cta: 'Set Date and Time',
    date_time_set: 'Date and time set to {0} {1}',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    second: 'Second',
    am_pm: 'AM/PM',
    serial_number: 'Serial number',
    device_name: 'Device Name',
    device_name_description: 'A human-readable label for this device.',
    device_name_label: 'Device Name',
    device_name_rename: 'Rename the device',
    device_name_saved: 'Device name saved',
    restart_server_app: 'Restart Server Application',
    restart_server_app_description: 'Restart the Ledium MEC server process. The page will automatically reload once the server is back online.',
    restart_server_app_button: 'Restart',
    restart_server_app_confirm: 'Are you sure you want to restart the server application?',
    restarting_server_app: 'Restarting...\nIt can take a moment.\nDo not refresh the page.',
    software_update: 'Software Update',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    password_incorrect: 'The current password is incorrect',
    password_changed: 'The password is changed',
    wifi_ap_settings: 'WiFi Access Point Settings',
    wifi_ap_ssid: 'SSID',
    wifi_ap_passphrase: 'Passphrase',
    wifi_ap_updated: 'WiFi AP settings updated',
    wifi_ap_ssid_invalid: 'SSID must be 1–32 characters (letters, digits, spaces, - . _)',
    wifi_ap_passphrase_invalid: 'Passphrase must be 8–63 characters (letters, digits, common symbols)',
    reboot: 'Reboot',
    shutdown: 'Shutdown',
    reboot_confirm: 'Are you sure you want to reboot the device?',
    shutdown_confirm: 'Are you sure you want to shut down the device?',
    power_management: 'Power Management',
    helper_unavailable_warning:
        'Some features are unavailable because a required system component is not installed on this device. The sections marked below have been disabled.',
    server_offline_warning: 'The device has no internet connection. The sections marked below have been disabled.',
    power_management_description: 'Reboot or shut down the device. The system will gracefully stop all running processes before executing the command.',
    rebooting: 'Device is rebooting...',
    shutting_down: 'Device is shutting down...',
    software_update_description: 'Check for and install application updates. The device must have internet access to search for new versions.',
    change_password_description: 'Change the password for your account.',
    export_database: 'Export Database',
    export_database_description: 'Download a zip archive of all database files for backup or migration purposes.',
    export_database_download: 'Download Database Export',
    import_database: 'Import Database',
    import_database_description:
        'Restore database files from a previously exported zip archive. All running projects will be stopped and the current data will be overwritten.',
    import_database_drop_or_select: 'Drag & drop a database export .zip here, or click to select',
    import_database_upload: 'Import',
    import_database_success: 'Database imported successfully',
    import_database_error_no_file: 'No file selected',
    import_database_error_missing_checksum: 'The file does not contain a checksum',
    import_database_error_hash_mismatch: 'File integrity check failed — the file may be corrupted or was not exported by this application',
    import_database_error_invalid_filename: 'Invalid filename — please use a file exported by this application',
    import_database_error_invalid_zip_contents: 'Invalid database archive - checksum validation failed',
    import_database_error_unknown: 'Import failed',
    cloud_backup: 'Cloud Backup',
    cloud_backup_description:
        'If enabled, your data will be automatically saved to the cloud every hour. You can restore a saved backup from the Cloud Import menu.',
    cloud_backup_enabled: 'Enable cloud backup',
    cloud_restore: 'Cloud Restore',
    cloud_restore_description: 'Load a previously saved backup from the cloud.',
    cloud_restore_open: 'Open Cloud Backup',
    cloud_restore_no_backups: 'No backups found.',
    cloud_restore_col_version: 'Version',
    cloud_restore_col_date: 'Date',
    cloud_restore_cta: 'Restore backup',
    cloud_restore_version_mismatch: 'Different version than current',
    cloud_restore_confirm_title: 'Restore backup',
    cloud_restore_confirm_message: 'Are you sure you want to restore the backup from version {0} saved on {1}? This will overwrite your current data.',
    wifi_ap_settings_description: 'Configure the built-in WiFi access point. Changes take effect immediately and will reconnect all WiFi clients.',
    tab_application: 'Application',
    tab_backup: 'Backup',
    tab_user: 'User',
    tab_system: 'System',

    date_and_time: 'Date and Time',
    date_and_time_description: 'Configure how dates and times are displayed throughout the application.',
    date_format: 'Date format',
    date_format_ymd: 'YYYY-MM-DD',
    date_format_mdy: 'MM/DD/YYYY',
    date_format_dmy: 'DD/MM/YYYY',
    time_format: 'Time format',
    time_format_24: '24-hour clock',
    time_format_12: '12-hour clock (AM/PM)',
    save_changes: 'Save changes',
    date_time_format_saved: 'Date and time format saved',

    zone: 'Zone',
    change: 'Change',
    zone_selector_show_all: 'Show all zones',
    zone_selector_hide_all: 'Hide all zones',
    zone_selector_showing_all: 'Showing all zones',
    zone_selector_select: 'Select Zone',
    zone_selector_add: 'Add Zone',
    zone_selector_edit: 'Edit Zones',
    zone_selector_edit_info:
        'Select a zone to edit or delete it. Drag to reorder or nest zones. Zones with devices cannot have child zones. Use Copy or Link to create mirrored or independent copies of a zone.',
    zone_all_warning: 'You are viewing all zones. Adding new items is disabled.',
    running_project_change_confirm: 'A project is currently running in this zone. Changes will take effect immediately. Continue?',
    add_new_disabled_no_zone: 'Select a zone to add items',
    light_channel_move_zone_confirm:
        'Move this device to {0}? It will be removed from all {1} spectrum mixes and added to all {0} spectrum mixes. This cannot be undone.',
    light_channel_move_zone_confirm_running: 'One or more projects are currently running and will be updated immediately.',

    zones_title: 'Zones',
    zones_description: 'Organise your lighting devices into zones — rooms, grow tents, climate chambers, or any other physical spaces',
    no_zone: 'You do not have any Zones now',
    search_for_zone: 'Search for Zones',
    zone_of_the_lighting_device: 'Zone of the Lighting Device:',
    select_zone_of_the_lighting_devices: 'Select zone of the Lighting Devices for this Spectrum Mix',
    select_zone_of_the_spectrum_mixes: 'Select zone of the Spectrum Mixes for this Project',
    spectrum_mixer_disabled_tree_selection: 'A Lighting Device is selected, zone switching is not possible.',
    project_editor_disabled_tree_selection: 'A Spectrum Mix is assigned, zone switching is not possible.',
    spectrum_mixer_no_light_in_zone: 'No light channels in this zone. Add light channels before creating a spectrum mix.',
    spectrum_mix_create_light_recipe: 'Create Lighting Recipe',
    spectrum_mix_create_light_recipe_created_title: 'Lighting Recipe Created',
    spectrum_mix_create_light_recipe_created_message: 'Lighting Recipe {0} was created. Would you like to use it for this Spectrum Mix?',
    spectrum_mix_create_light_recipe_exists_title: 'Lighting Recipe Already Exists',
    spectrum_mix_create_light_recipe_exists_message: 'A {0} lighting recipe with this spectrum already exists. Would you like to use it for this Spectrum Mix?',
    spectrum_mix_no_light_recipe_title: 'No Lighting Recipe',
    spectrum_mix_no_light_recipe_message: 'This Spectrum Mix does not have a Lighting Recipe. Would you like to create one from this spectrum?',
    parent_zone: 'Parent zone:',
    change_parent: 'Change parent',
    light_channel_zone: 'Zone: {0}',
    copy: 'Copy',
    back: 'Back',
    next: 'Next',
    copy_zone_wizard_title: 'Copy / Link project',
    copy_zone_step1_label: 'What is this?',
    copy_zone_step2_label: 'Choose scenario',
    copy_zone_step3_label: 'Name',
    copy_zone_step4_label: 'Map channels',
    copy_zone_step5_label: 'Summary',
    copy_zone_step1_description: 'This wizard lets you reuse an existing zone in one of the following ways:',
    copy_zone_copy_description:
        'Creates a fully independent duplicate. Light channels are cloned with new DMX addresses. Spectrum mixes are cloned with updated channel references. Growth recipe and light recipes are shared, not duplicated.',
    copy_zone_step1_note: 'No changes are saved until you confirm on the final step.',
    copy_zone_step2_heading: 'How do you want to reuse this zone?',
    copy_zone_copy_sublabel: 'Creates a fully independent duplicate.',
    copy_zone_link_sync_label: 'Link — Sync mirror',
    copy_zone_link_sync_sublabel: 'Zones run in lockstep; controlled together.',
    copy_zone_link_independent_label: 'Link — Independent',
    copy_zone_link_independent_sublabel: 'Zones share the schedule but start/stop separately.',
    copy_zone_coming_soon: 'Coming soon',
    copy_zone_confirm: 'Create copy',
    copy_zone_success: 'Zone copied successfully.',
    copy_zone_step3_description: 'This will create a new independent zone. Give it a name to continue.',
    copy_zone_step3_name_label: 'New zone name',
    copy_zone_step4_search_free: 'Search free DMX channels',
    copy_zone_step4_description:
        'Assign a new DMX address to each light channel used by this zone. Use the test button to verify the channel at the new address.',
    copy_zone_step5_description:
        "Clicking 'Create copy' will create a new zone, a new project, new lighting device copies and new spectrum mix copies. All new items will be named after the new zone.",
    copy_zone_step5_new_zone: 'New zone',
    copy_zone_step5_new_project: 'New project',
    copy_zone_step5_devices: 'Lighting devices',
    copy_zone_step5_mixes: 'Spectrum mixes',
    link: 'Link',
    linked_project_status_enabled: 'Enabled',
    linked_project_status_disabled: 'Disabled',
    linked_project_status_mapping_error: 'Mapping error',
    linked_project_edit_mapping: 'Edit mapping',
    linked_project_deleted_channel: 'Deleted channel',
    linked_project_none: 'No sync links.',
    linked_project_count_badge: '{0} linked {0,choice,1#project|1<projects}',
    linked_project_error_badge: '{0} linked {0,choice,1#zone|1<zones} with mapping error',
    start_project_mapping_error_title: 'Mapping Error in Sync-Mirrored Zones',
    start_project_mapping_error_body:
        'This project has {0} sync-mirrored {0,choice,1#zone|1<zones} with a mapping error. If you start the project, {0,choice,1#this zone|1<these zones} will not be mirrored.',
    start_project_mapping_error_fix: 'You can fix this issue on the {0}.',
    start_project_mapping_error_zones_link: 'Zone Settings page',
    linked_project_disable: 'Disable',
    linked_project_enable: 'Enable',
    linked_project_delete_title: 'Delete sync link',
    linked_project_delete_message: 'Are you sure you want to delete this sync link?',
    linked_project_deleted: 'Sync link deleted.',
    linked_project_updated: 'Sync link updated.',
    linked_project_health: '{0} of {1} channels mapped',
    linked_project_type_mirror: 'Mirrored',
    linked_project_type_independent: 'Independent',
    linked_project_mirror_badge: '{0} {0,choice,1#mirrored zone|1<mirrored zones}',
    linked_project_mirror_description: 'These zones are synced — starting or stopping this project will affect all of them.',
    linked_project_independent_badge: 'Independent link of zone {0}',
    linked_project_independent_description: 'This project is a link of "{0}" in zone "{1}" — it runs independently and can be started and stopped separately.',
    linked_project_inline_header: '{0} linked {0,choice,1#project|1<projects}',
    linked_zone_inline_header: '{0} linked {0,choice,1#zone|1<zones}',
    linked_zone_type_label: 'Type',
    linked_zone_status_label: 'Status',
    linked_zone_enable_running_title: 'Enable Sync Link',
    linked_zone_enable_running_message:
        'Project "{0}" is currently running in this zone. If you enable this link, it will start mirroring the source project at its current point — not from the beginning. Are you sure you want to enable it?',
    linked_zone_disable_running_title: 'Disable Sync Link',
    linked_zone_disable_running_message:
        'Project "{0}" is currently running in this zone. If you disable this link, it will stop immediately while the source project continues running. Are you sure you want to disable it?',
    linked_zone_independent_disable_message:
        '{0} project{0,choice,1#|1<s} are running or paused in this linked zone and will be stopped when the link is disabled. Are you sure you want to disable it?',
    linked_zone_delete_running_title: 'Delete Sync Link',
    linked_zone_delete_running_message:
        'Project "{0}" is currently running in this zone. If you delete this link, it will stop immediately while the source project continues running. Are you sure you want to delete it?',
    linked_zone_switch_type_button: 'Switch type',
    linked_zone_switch_to_mirror_title: 'Switch to Sync Mirror',
    linked_zone_switch_to_mirror_running_virtual: '{0} project{0,choice,1#|1<s} in the linked zone will be stopped.',
    linked_zone_switch_to_mirror_running_source: 'The source project is running — mirroring will resume immediately.',
    linked_zone_switch_to_independent_title: 'Switch to Independent',
    linked_zone_switch_to_independent_running_source: 'The source project is running — the linked zone will go dark until you manually start its projects.',
    project_has_independent_copies_title: 'Delete Project',
    project_has_independent_copies_message:
        'This project has {0} independent linked zone cop{0,choice,1#y|1<ies}. Deleting it will stop and remove all copies. Are you sure?',
    copy_zone_confirm_link: 'Create link',
    copy_zone_link_success: 'Sync link created successfully.',
    copy_zone_link_sync_step3_description: "This will create a sync link. The linked zone will mirror the source zone's DMX output at new addresses.",
    copy_zone_link_independent_step3_description:
        'This will create an independent link. The linked zone will share the same schedule but projects can be started and stopped separately.',
    copy_zone_link_sync_step4_heading: 'Assign new DMX addresses',
    copy_zone_link_sync_step4_description:
        'Assign a new DMX address to each light channel. These addresses will receive the mirrored DMX signal from the source zone.',
    copy_zone_channel_name: 'Channel name',
    copy_zone_original_dmx: 'Original DMX',
    copy_zone_new_dmx: 'New DMX',
    copy_zone_link_sync_step5_description:
        "Clicking 'Create link' will create a sync link. The source zone will fan out its DMX output to the mapped addresses.",
    copy_zone_link_independent_step5_description:
        "Clicking 'Create link' will create an independent link. Each source project will have a separate copy in the linked zone that you can start and stop independently.",
    copy_zone_link_name: 'Link name',
    copy_zone_link_channel_mapping: 'Channel mapping',
    copy_link_zone: 'Copy / Link Zone',
    error_loading_data: 'Failed to load data. Please try again.',

    X_is_successfully_deleted: '{0} is successfully deleted',
    settings_saved: 'Settings saved',
    settings_save_error: 'Failed to save settings',
    date_time_saved: 'Date and time saved',
    action_failed: 'Action failed',
    project_action_failed: 'Project action failed',
    light_recipe_created: 'Lighting Recipe created',
    zone_updated: 'Zone updated',
    zone_created: 'Zone created',
    zone_reorder_failed: 'Failed to save zone order',
    dmx_test_sent: 'DMX test signal sent',
    dmx_test_failed: 'DMX test failed',
    all_projects_stopped: 'All projects stopped',
    section_jumped: 'Section skipped',
    error_occurred: 'An error occurred',
    dark_mode: 'Dark mode',
    light_mode: 'Light mode'
};
